export type CustomerInformationQuery__QueryKeyType = string;

const baseKey = `bbnt-customer-information-query`;

export const CustomerInformationQuery__QueryKey = {
  customerInformation: (): CustomerInformationQuery__QueryKeyType => {
    const baseQueryKey = baseKey;

    const queryKey: CustomerInformationQuery__QueryKeyType = baseQueryKey;

    return queryKey;
  },
};
